<div class="p-6">
  <h2 class="text-2xl font-semibold mb-4">Category Management</h2>

  <!--<a routerLink="/admin/categories/create"
     class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
    + Add Category
  </a>-->

  <div *ngIf="loading" class="mt-4">Loading...</div>

  <app-category-tree [categories]="categories"></app-category-tree>

  <!--<ul class="mt-6 space-y-2">
    <ng-container *ngFor="let cat of categories">
      <li class="border p-4 rounded-lg bg-white shadow">
        <div class="flex justify-between items-center">
          <span class="font-medium">{{ cat.name }}</span>
          <div class="space-x-2">
            <a [routerLink]="['/admin/categories/edit', cat.id]"
               class="text-blue-600 hover:underline">Edit</a>
            <button (click)="deleteCategory(cat.id)"
                    class="text-red-600 hover:underline">
              Delete
            </button>
          </div>
        </div>-->
  <!-- Recursive Subcategories -->
  <!--<ul *ngIf="cat.children?.length" class="ml-6 mt-2 space-y-1">
          <li *ngFor="let sub of cat.children" class="pl-2 border-l">
            <div class="flex justify-between items-center">
              <span>{{ sub.name }}</span>
              <div class="space-x-2">
                <a [routerLink]="['/admin/categories/edit', sub.id]"
                   class="text-blue-600 hover:underline">Edit</a>
                <button (click)="deleteCategory(sub.id)"
                        class="text-red-600 hover:underline">
                  Delete
                </button>
              </div>
            </div>
          </li>
        </ul>
      </li>
    </ng-container>
  </ul>-->
</div>
